"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var styles = {
  "container": "modal-module__container___Ku1J4",
  "content": "modal-module__content___PyMUc"
};
const modalRoot = document.getElementById('modal');
class Modal extends _react.default.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.el.className = styles.content;
  }
  componentDidMount() {
    if (modalRoot) {
      modalRoot.classList.add(styles.container);
      modalRoot.appendChild(this.el);
    } else {
      console.error('DOM element with `id="modal" is missing. Check out your "index.html"`'); // eslint-disable-line no-console
    }
  }

  componentWillUnmount() {
    if (modalRoot) {
      modalRoot.classList.remove(styles.container);
      modalRoot.removeChild(this.el);
    }
  }
  render() {
    return /*#__PURE__*/_reactDom.default.createPortal(this.props.children, this.el);
  }
}
exports.default = Modal;